import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  TIndirectTaxCustomerExtend,
  TIndirectTaxCustomerGetResponse,
  TIndirectTaxCustomerHookParams,
} from './types';

export function useIndirectTaxCustomer({
  customerId,
  corporationId,
}: TIndirectTaxCustomerHookParams) {
  const query = new URLSearchParams();

  query.append('extend', TIndirectTaxCustomerExtend.SHIPPING_ADDRESS);
  if (corporationId !== undefined) {
    query.append('corporation_id', corporationId.toString());
  }

  const { data, mutate, error, isLoading } =
    useSWR<TIndirectTaxCustomerGetResponse>(
      customerId && corporationId
        ? `new-sales-tax/customers/${customerId}?${query}`
        : null,
      SWRFetcher({ method: 'GET' }, undefined)
    );

  return {
    customer: data?.data,
    mutate,
    error,
    isLoading,
  };
}
